export default {"src":"/_next/static/media/company2.8e7e4c61.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};